import { I18n } from 'react-redux-i18n';

function statusOutboundLoad(status) {
  if (status || status === 0) {
    switch (status) {
      case 1:
        return I18n.t('BEE4531' /* Pendente Liberação */);
      case 2:
        return I18n.t('BEE1365' /* Pendente Separação */);
      case 3:
        return I18n.t('BEE1367' /* Em Separação */);
      case 4:
        return I18n.t('BEE1768' /* Em Conferência */);
      case 5:
        return I18n.t('BEE1949' /* Pendente Docas */);
      case 6:
        return I18n.t('BEE1766' /* Finalizado */);
      case 7:
        return I18n.t('BEE64' /* Cancelado */);
      default:
        return status;
    }
  } else if (!status) {
    return [
      { value: 1, label: I18n.t('BEE4531' /* Pendente Liberação */) },
      { value: 2, label: I18n.t('BEE1365' /* Pendente Separação */) },
      { value: 3, label: I18n.t('BEE1367' /* Em Separação */) },
      { value: 4, label: I18n.t('BEE1768' /* Em Conferência */) },
      { value: 5, label: I18n.t('BEE1949' /* Pendente Docas */) },
      { value: 6, label: I18n.t('BEE1766' /* Finalizado */) },
      { value: 7, label: I18n.t('BEE64' /* Cancelado */) },
    ];
  }
}

export default {
  statusOutboundLoad,
};
